<template>
  <section class="library-page">
    <section class="library-hero">
      <div class="library-hero-main">
        <p class="library-kicker">BV627 MEDIA ASSET STORAGE TERMINAL</p>
        <h1 class="library-title">资源库</h1>
        <p class="library-lead">
          这里不是普通下载页，这里是 BV627 媒体资产暂时决定离开服务器、前往你设备里的中转大厅。
          每一份素材都很安静地躺着，但姿态上仍然保持一种夸张到略带庄严的抽象感。
        </p>
      </div>

      <div class="library-hero-side">
        <p class="library-side-title">下载须知</p>
        <p class="library-side-copy">
          点击下载，不代表你只是拿走了一个文件。
          更准确地说，你是把一小块 BV627 的视觉噪声、品牌空气和气氛材料打包带走了。
        </p>
      </div>
    </section>

    <section class="library-broadcast">
      <div class="library-broadcast-inner">
        <p class="library-broadcast-kicker">特别播报</p>
        <p class="library-broadcast-copy">
          本资源库采用数组召唤制，不靠后台，不靠搜索，也不靠任何看起来很高级其实未必有用的东西。
          只需要标题、介绍、下载链接，素材就会自己排队出现。
        </p>
      </div>
    </section>

    <section class="library-grid">
      <article
        v-for="(asset, index) in assetLibraryItems"
        :key="asset.title"
        class="library-card"
      >
        <p class="library-card-index">ASSET {{ String(index + 1).padStart(2, "0") }}</p>
        <h2 class="library-card-title">{{ asset.title }}</h2>
        <p class="library-card-copy">{{ asset.description }}</p>
        <a
          class="library-card-link"
          :href="asset.downloadUrl"
          target="_blank"
          rel="noreferrer"
          :download="asset.title"
        >
          立即接走这个素材
        </a>
      </article>
    </section>
  </section>
</template>

<script setup>
import { assetLibraryItems } from "@/data/assetLibrary";
</script>

<style scoped>
.library-page {
  width: min(1280px, calc(100vw - 28px));
  margin: 0 auto;
  padding: 28px 0 56px;
  color: #f7f1e8;
}

.library-hero,
.library-broadcast-inner,
.library-card,
.library-manifesto {
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 32px;
  background:
    radial-gradient(circle at top left, rgba(255, 240, 0, 0.14), transparent 24%),
    linear-gradient(150deg, rgba(24, 18, 10, 0.96), rgba(10, 11, 16, 0.96));
  box-shadow:
    0 24px 60px rgba(0, 0, 0, 0.36),
    inset 0 1px 0 rgba(255, 255, 255, 0.06);
}

.library-hero {
  padding: 30px;
  display: grid;
  grid-template-columns: minmax(0, 1.7fr) minmax(280px, 0.9fr);
  gap: 18px;
  transform: rotate(-0.6deg);
}

.library-kicker,
.library-broadcast-kicker,
.library-card-index {
  margin: 0 0 10px;
  color: #fff000;
  font-size: 12px;
  letter-spacing: 4px;
  text-transform: uppercase;
}

.library-title {
  margin: 0;
  color: #fffdf7;
  font-size: clamp(56px, 11vw, 110px);
  line-height: 0.88;
  text-shadow:
    0 0 18px rgba(255, 240, 0, 0.18),
    4px 4px 0 rgba(0, 0, 0, 0.32);
}

.library-lead,
.library-side-copy,
.library-broadcast-copy,
.library-card-copy,
.library-manifesto-text {
  margin: 14px 0 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: 19px;
  line-height: 1.7;
}

.library-hero-side {
  padding: 22px;
  border: 1px dashed rgba(255, 240, 0, 0.28);
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.04);
  transform: rotate(1.4deg);
}

.library-side-title {
  margin: 0;
  color: #fff;
  font-size: 28px;
}

.library-broadcast {
  margin-top: 18px;
}

.library-broadcast-inner {
  padding: 24px 28px;
  transform: rotate(0.5deg);
}

.library-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  margin-top: 18px;
}

.library-card {
  --card-tilt: 0deg;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 100%;
  transform: rotate(var(--card-tilt));
}

.library-card:nth-child(1) {
  --card-tilt: -1deg;
}

.library-card:nth-child(2) {
  --card-tilt: 0.7deg;
}

.library-card:nth-child(3) {
  --card-tilt: -0.5deg;
}

.library-card-title,
.library-manifesto-title {
  margin: 0;
  color: #fff;
  font-size: clamp(28px, 4vw, 44px);
  line-height: 1.05;
}

.library-card-link {
  width: fit-content;
  margin-top: auto;
  padding: 12px 18px;
  border-radius: 999px;
  border: 2px solid rgba(255, 240, 0, 0.34);
  color: #fff000;
  background: rgba(255, 240, 0, 0.08);
  font-size: 15px;
  font-weight: 700;
  transition: transform 0.2s ease, background 0.2s ease, color 0.2s ease;
}

.library-card-link:hover {
  transform: translateY(-2px);
  color: #171203;
  background: #fff000;
}

.library-manifesto {
  margin-top: 18px;
  padding: 28px;
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(320px, 0.85fr);
  gap: 18px;
}

.library-code {
  margin: 0;
  padding: 20px;
  border-radius: 24px;
  overflow-x: auto;
  background: rgba(0, 0, 0, 0.44);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #fff790;
  font-size: 15px;
  line-height: 1.7;
}

.library-code code {
  font-family: "Comic Sans", "Smiley Sans", Arial, sans-serif;
}

@media (max-width: 980px) {
  .library-hero,
  .library-manifesto {
    grid-template-columns: 1fr;
  }

  .library-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 720px) {
  .library-page {
    width: min(calc(100vw - 18px), 1280px);
    padding-top: 20px;
  }

  .library-hero,
  .library-broadcast-inner,
  .library-card,
  .library-manifesto {
    padding: 20px 18px;
    border-radius: 24px;
  }

  .library-lead,
  .library-side-copy,
  .library-broadcast-copy,
  .library-card-copy,
  .library-manifesto-text {
    font-size: 17px;
  }

  .library-side-title {
    font-size: 24px;
  }
}
</style>
